import React, { FC } from 'react';
import { Box, Text } from '@bechtel/gds';
import { CostCode } from '@bechtel/types';
import { TotalContainerStyled, TotalCellStyled } from './styled';
import { map } from 'lodash';
import { TotalHeaderColumnStyled } from '~/detail/styled';
import { StickyBoxStyled } from '../styled';

interface CostCodeHeaderTotalProps {
  costCode: CostCode;
  totalHrs: number[];
}
export const CostCodeHeaderTotal: FC<CostCodeHeaderTotalProps> = ({ costCode, totalHrs }) => {
  return (
    <TotalContainerStyled>
      <StickyBoxStyled>
        <TotalHeaderColumnStyled>
          <Box pl={{ sm: '400' }} py={{ sm: '500' }}>
            <Text color="grey.1000" size="300" weight="600">
              {costCode.costCode}
            </Text>
          </Box>
        </TotalHeaderColumnStyled>
      </StickyBoxStyled>
      <Box alignItems={{ sm: 'center' }} flexGrow={{ sm: 1 }}>
        {map(totalHrs, (totalHr, index) => {
          return (
            <TotalCellStyled key={index}>
              <Text color="grey.1000" size="300" weight="600" family="graphik">
                {totalHr}
              </Text>
            </TotalCellStyled>
          );
        })}
      </Box>
    </TotalContainerStyled>
  );
};
